import "./App.css";
import Dashboard from "./Pages/Dashboard/Dashboard";
import SignIn from "./Pages/SignIn";
import ForgotPassword from "./Pages/ForgotPassword";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SignUp from "./Pages/SIgnUp";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoutes from "./PrivateRoute/PrivateRoutes";
// import AntenatalCare from "./Pages/AntenatalCare/AntenatalCare";
import ConcernData from "./Pages/ConcernData/ConcernData";
import Articles from "./Pages/Articles/Articles";
import ConcernDataDashboard from "./Pages/ConcernData/ConcernDataDashboard";
import UserData from "./Pages/UserData/UserData";
import Analytics from "./Pages/Analytics/Analytics";

function App() {
  return (
    <>
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route exact element={<PrivateRoutes />}>
            <Route path="/Dashboard" element={<Dashboard />} />
            <Route path="/concerns" element={<ConcernData />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/analytics" element={<Analytics />} />

            <Route path="/concernData/:id" element={<ConcernDataDashboard />} />
            <Route path="/UserData" element={<UserData />} />
          </Route>
          <Route path="/SignUp" element={<SignUp />} />
          <Route path="/ResetPassword" element={<ForgotPassword />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
